import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-stock-location',
  templateUrl: './stock-location.component.html',
  styleUrls: ['./stock-location.component.css']
})
export class StockLocationComponent implements OnInit {
    stockZoneKeyno;

    public stockLocationKeyno;

    public webPageName: string = this.stateService.getCurrentName();

    public edit?: Edit;

    public selectListStockZones: Item[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockZoneKeyno = this.stateService.getStateParams()['stockzone_keyno'];
        this.stockLocationKeyno = this.stateService.getStateParams()['stocklocation_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockZoneKeyno && !!this.stockLocationKeyno) {
            this.edit = (await this.datatask.Post(936, {
                stockzone_keyno: this.stockZoneKeyno,
                stocklocation_keyno: this.stockLocationKeyno
            }))[0];
        }
    }

    private async loadStockZones(): Promise<void> {
        if (!!this.edit?.stockplace_id) {
            this.selectListStockZones = await this.datatask.Post(929, { stockplace_id: this.edit.stockplace_id });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(937, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(938, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadStockZones();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stocklocation_keyno: string;
    stockzone_keyno: number;
    description: string;
    stockzone_name: string;
    stockplace_name: string;
    sortorder: number;
    isactive: number;
    stockplace_id: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockLocation', {
//        templateUrl: 'views/components/views/stockLocation/stockLocation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'stockLocationService', 'logisticService', function ($stateParams, stateService, utilityService, translateService, modalService, stockLocationService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockZoneKeyno = $stateParams.stockzone_keyno;
//            let stockLocationKeyno = $stateParams.stocklocation_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                stockLocationKeyno: stockLocationKeyno,
//                edit: {},
//                selectListStockZones: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await stockLocationService.getEdit({
//                    stockzone_keyno: stockZoneKeyno,
//                    stocklocation_keyno: stockLocationKeyno
//                }))[0];

//                return loadStockZones();
//            }

//            async function loadStockZones() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id) !== true) return;

//                return vm.model.selectListStockZones = await logisticService.listStockZones({ stockplace_id: vm.model.edit.stockplace_id });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'selectreport':
//                        go({
//                            webpage_name: stateService.getCurrentName(),
//                            argtype: 'stocklocation_keyno',
//                            argvalue: vm.model.edit.stocklocation_keyno
//                        });
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockLocationService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    stockLocationService.deleteItem(vm.model.edit).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
